import MigrationItemViewDTO from '@src/adapters/dto/migration/MigrationItemViewDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
}

interface Result {
  items: MigrationItemViewDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/migration/items',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetMigrationItems = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useGetMigrationItemsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetMigrationItems;
